export default __webpack_public_path__ + "static/media/spinBackground.7d6cad58.png";